import React, { Component } from "react";
import { Router, Route, Redirect } from "react-router-dom";
import HistoryHelper from "./helpers/history-helper";

import "./css/App.css";
import "@fortawesome/fontawesome-free/js/all";

import Visor from "./components/visor/Visor";
import Login from "./components/login/Login";
import ProyectoForm from "./components/proyecto/ProyectoForm";
import TopMenu from "./components/navigation/TopMenu";
import ProyectoList from "./components/proyecto/ProyectoList";

import keycloakHelper from "./helpers/keycloak-helper";
import Loading from "./components/common/Loading";
import ProyectoView from "./components/proyecto/ProyectoView";

/**
 * Componente princiapl de la aplicación.
 */
class App extends Component {
  /**
   * almacena el estado del componente.
   */
  state = {
    session: false
  };

  /**
   * Se encarga de inicializar el keycloak helper para
   * cargar las configuraciones e inicializar el adapter.
   */
  componentDidMount() {
    keycloakHelper.init(() => {
      this.setState({ session: true });
    });
  }

  /**
   * Se encarga de renderizar las rutas de la aplicación, esto es para
   * que se carguen los componentes únicamente cuando se inicializa el
   * adapter de keycloak. Con esto se asegura que los componentes siempre
   * manejen el estaod de la sesión.
   */
  routes() {
    return (
      <React.Fragment>
        <TopMenu />
        <div className="main-content">
          <Route path="/visor" component={Visor} />
          <Route exact path="/proyectos/" component={ProyectoList} />
          <Route path="/proyectos/crear" component={ProyectoForm} />
          <Route path="/proyectos/:id/editar" component={ProyectoForm} />
          <Route path="/proyectos/:id/ver" component={ProyectoView} />
          <Route path="/login" component={Login} />
          <Route
            exact
            path="/"
            render={() => (
              <Redirect to={`/visor${HistoryHelper.location.search}`} />
            )}
          />
        </div>
      </React.Fragment>
    );
  }

  /**
   * Se encarga de renderizar el componente.
   */
  render() {
    if (!this.state.session) {
      return <Loading />;
    }
    return (
      <Router history={HistoryHelper}>
        <div className="App">{this.routes()}</div>
      </Router>
    );
  }
}

export default App;
